import React from 'react';
import PropTypes from 'prop-types';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import Accordion from '@material-ui/core/Accordion';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Typography from '@material-ui/core/Typography';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { Paper } from '@material-ui/core';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import OrderSummaryHandler from '../OrderSummary/OrderSummaryHandler';
import { formatTimestamp } from '../../helpers/time';
import { formatCurrency } from '../../helpers';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%'
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary
  },
  orderDetails: {
    backgroundColor: theme.palette.grey[100],
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(3),
    width: '100%',
    marginLeft: 'auto',
    marginRight: 'auto'
  },
  largeIcon: {
    width: '1.3em',
    height: '1.3em'
  }
}));

const OrdersList = ({ orders }) => {
  const classes = useStyles();

  if (!orders.length) {
    return <Typography className={classes.heading}>No orders yet.</Typography>;
  }

  return (
    <div className={classes.root}>
      {orders.map(order => (
        <Accordion key={order.id} TransitionProps={{ mountOnEnter: true }}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />} IconButtonProps={{ color: 'primary' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
              <div style={{ display: 'flex', flexDirection: 'row' }}>
                <Typography variant="body2" style={{ marginRight: '4px' }}>
                  {formatTimestamp(order.invoice_date || order.created_at, {
                    format: 'YYYY-MMM-DD'
                  })}
                </Typography>
                <Typography
                  variant="caption"
                  style={{ color: order.fm_invoice_status === 'PAID' ? 'green' : 'red' }}
                >
                  <i>{order.fm_invoice_status}</i>
                </Typography>
              </div>
              <div>
                <Typography variant="body2">{order.invoice_label}</Typography>
              </div>
              <div style={{ minWidth: '120px', textAlign: 'right' }}>
                <Typography className={classes.secondaryHeading}>
                  {formatCurrency(order.total)}
                </Typography>
              </div>
            </div>
          </AccordionSummary>
          <AccordionDetails>
            <Paper className={classes.orderDetails}>
              <OrderSummaryHandler orderId={order.id} />
            </Paper>
          </AccordionDetails>
        </Accordion>
      ))}
    </div>
  );
};

OrdersList.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  orders: PropTypes.array
};

OrdersList.defaultProps = {
  orders: []
};

export default OrdersList;
